  <app-user-dashboard [fullScreen]="true">
    <app-content-body>
      <div class="bg-container">
        <div class="container custom-tabview">
          <p-tabView [(activeIndex)]="tabIndex">
            <p-tabPanel header="{{'ExternalMarketPlace.MarketplaceTabTitle' | translate}}">
              <div class="only-desktop">
                <div>
                  <form [formGroup]="formGroup" class="marketplace-filters-container">
                    <div class="p-fluid grid">
                      <div class="col-12 md:col-4 lg:col-2 pb-0 mb-0">
                        <span class="p-float-label">
                          <p-dropdown
                            [options]="originCountries"
                            formControlName="countryFromId"
                            optionLabel="name"
                            optionValue="id"
                            (onChange)="onChangeCountryFrom()"
                            (onClear)="clearSpotSearchParams()"
                            [filter]="true"
                            filterBy="name"
                            [showClear]="true"
                            placeholder="{{'MarketplacePage.Spot.ImportFromFieldPlaceholder' | translate}}"
                            class="p-inputtext-sm custom-dropdown bg-form">
                            <ng-template pTemplate="selectedItem">
                              <div class="flex align-items-center gap-2" *ngIf="selectedCountryFrom">
                                <img [flag]="selectedCountryFrom.code" style="width: 18px" alt="flag"/>
                                <div>{{ selectedCountryFrom | countryDescription }}</div>
                              </div>
                            </ng-template>
                            <ng-template let-country pTemplate="item">
                              <div class="flex align-items-center gap-2">
                                <img [flag]="country" style="width: 18px" alt="flag"/>
                                <div>{{ country | countryDescription }}</div>
                              </div>
                            </ng-template>
                          </p-dropdown>
                          <label class="export-from-label">{{'MarketplacePage.Spot.ImportFromFieldLabel' | translate}}</label>
                        </span>
                      </div>
                      <div class="col-12 md:col-4 lg:col-6 pb-0 mb-0">
                        <span class="p-input-icon-left">
                          <i class="custom-input-icon pi pi-search"></i>
                          <input formControlName="filter" type="text" pInputText (input)="filterGlobalEvent($event)"
                            placeholder="{{'MarketplacePage.Spot.SearchProducts' | translate}}"
                            class="custom-input w-full"/>
                        </span>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div class="only-mobile pd-lat">
                <div>
                  <form [formGroup]="filterForm" class="marketplace-filters-container">
                    <div class="p-fluid grid">
                      <div class="col-12 md:col-4 lg:col-6 pb-0 mb-0">
                        <span class="p-input-icon-left">
                          <i class="custom-input-icon pi pi-search"></i>
                          <input type="text" pInputText formControlName="filterMobile"
                            placeholder="{{'MarketplacePage.Spot.SearchProducts' | translate}}"
                            class="custom-input w-full" />
                        </span>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div class="only-desktop mg-top w-full">
                <p-table #dt1
                  [value]="filteredOffers"
                  dataKey="adsCode"
                  [paginator]="true"
                  [rows]="10"
                  [showCurrentPageReport]="true"
                  [rowsPerPageOptions]="[10, 25, 50]"
                  [loading]="loading"
                  [globalFilterFields]="['variety.species.name', 'variety.name', 'speciesSize']"
                  responsiveLayout="stack"
                  [breakpoint]="'600px'"
                  class="custom-table">

                  <ng-template pTemplate="header">
                    <tr>
                      <th class="text-center">
                        <div class="flex align-items-center title-column justify-content-center">
                          {{'MarketplacePage.Spot.MarketPlaceTable.CountryHeader' | translate}}
                        </div>
                      </th>
                      <th class="text-center">
                        <div class="flex align-items-center title-column justify-content-center">
                          {{'MarketplacePage.Spot.MarketPlaceTable.SpecieHeader' | translate}}
                          <p-columnFilter field="specieName" matchMode="in" display="menu"
                            [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                            <ng-template pTemplate="header">
                              <div class="px-3 pt-3 pb-0">
                                <span class="font-bold">{{'MarketplacePage.Spot.MarketPlaceTable.SelectSpecieText' |
                                  translate}}</span>
                              </div>
                            </ng-template>
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                              <p-multiSelect
                                [options]="speciesFilter"
                                [ngModel]="value"
                                placeholder="{{'MarketplacePage.Spot.MarketPlaceTable.SelectText' | translate}}"
                                (onChange)="filter($event.value)"
                                optionValue="value"
                                optionLabel="label"/>
                            </ng-template>
                          </p-columnFilter>
                        </div>
                      </th>
                      <th class="text-center" pSortableColumn="variety.name">
                        <div class="flex align-items-center title-column justify-content-center">
                          {{'MarketplacePage.Spot.MarketPlaceTable.VarietyHeader' | translate}}
                          <p-columnFilter field="variety.name" matchMode="in" display="menu"
                            [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                            <ng-template pTemplate="header">
                              <div class="px-3 pt-3 pb-0">
                                <span class="font-bold">{{'MarketplacePage.Spot.MarketPlaceTable.SelectVarietyText' |
                                  translate}}</span>
                              </div>
                            </ng-template>
                            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                              <p-multiSelect
                                [options]="varietiesFilter"
                                [ngModel]="value"
                                placeholder="{{'MarketplacePage.Spot.MarketPlaceTable.SelectText' | translate}}"
                                (onChange)="filter($event.value)"
                                optionValue="value"
                                optionLabel="label"/>
                            </ng-template>
                          </p-columnFilter>
                          <p-sortIcon field="variety.name"></p-sortIcon>
                        </div>
                      </th>
                      <th style="text-align:-webkit-center" class="text-center" pSortableColumn="speciesSize">
                        <div class="flex align-items-center title-column">
                          {{'MarketplacePage.Spot.MarketPlaceTable.SizeHeaderHeader' | translate}}
                          <p-columnFilter type="text" field="speciesSize" display="menu"
                            [showAddButton]="false" [showMatchModes]="false" [showOperator]="false"
                            [matchMode]="'contains'"></p-columnFilter>
                          <p-sortIcon field="speciesSize"></p-sortIcon>
                        </div>
                      </th>
                      <th class="text-center">
                        <div class="flex align-items-center text-center justify-content-center">
                          {{'MarketplacePage.Spot.MarketPlaceTable.QualityControlHeader' | translate}}
                          <p-columnFilter type="boolean" field="isQualityControl" display="menu"
                            [showAddButton]="false" [showMatchModes]="false" [showOperator]="false"/>
                        </div>
                      </th>
                      <th pSortableColumn="harvestDate">
                        <div class="flex align-items-center title-column">
                          {{'MarketplacePage.Spot.MarketPlaceTable.HarvestDateHeader' | translate}}
                          <p-columnFilter type="date" field="harvestDate" [locale]="locale"
                            display="menu" [showAddButton]="false" [showMatchModes]="false"
                            [showOperator]="false" matchMode="filter-date"></p-columnFilter>
                          <p-sortIcon field="harvestDate"></p-sortIcon>
                        </div>
                      </th>
                      <th class="text-center">
                        <div class="flex align-items-center title-column justify-content-center">
                          {{'MarketplacePage.Spot.MarketPlaceTable.CasePerPalletsHeader' | translate}}
                        </div>
                      </th>
                      <th pSortableColumn="listPrice">
                        <div class="flex align-items-center title-column">
                          {{'MarketplacePage.Spot.MarketPlaceTable.ListPrice' | translate}}
                          <p-sortIcon field="listPrice"></p-sortIcon>
                        </div>
                      </th>
                      <th class="text-center" pSortableColumn="availablePallets">
                        <div class="flex align-items-center title-column justify-content-center">
                          {{'MarketplacePage.Spot.MarketPlaceTable.AvailablePalletsHeader' | translate}}
                          <p-sortIcon field="availablePallets"></p-sortIcon>
                        </div>
                      </th>
                      <th class="text-center" colspan="2">
                        <div class="flex align-items-center title-column justify-content-center">
                          {{'MarketplacePage.Spot.MarketPlaceTable.SeeAdOffer' | translate}}
                        </div>
                      </th>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="body" let-offer>

                    <tr [pSelectableRow]="offer">
                      <!--
                      -->
                      <td class="text-center" [ngClass]="'td-table'">
                        <img [flag]="offer.country" class="row-img" alt=""/>
                      </td>
                      <td class="text-center">
                        <img [src]="offer.variety.urlIcon | speciesImageUrl" class="row-img" style="padding: 2px; border-radius: 7px;" alt=""/>
                      </td>
                      <td class="text-center">{{offer.variety.name}}</td>
                      <td style="text-align:center" class="text-center size-column">
                        <app-text-preview-tooltip [text]="offer.speciesSize"/>
                      </td>
                      <td class="text-center">{{offer.isQualityControl ? 'Sí' : 'No'}}</td>
                      <td *ngIf="offer.harvestTypeId == 1" >
                        {{offer.harvestDate | date: 'dd/MM/yyyy'}}
                      </td>
                      <td *ngIf="offer.harvestTypeId == 2 || offer.harvestTypeId == 3 " >
                        <div class="flex flex-row">
                          {{offer.harvestStartDate | date: 'dd/MM/yyyy'}} - {{offer.harvestEndDate | date: 'dd/MM/yyyy'}}
                        </div>
                      </td>
                      <td class="text-center">{{offer.caseQuantityPerPallet}}</td>
                      <td>{{offer.listPrice | currency: 'USD':'US$'}}{{offer.typeSale}}</td>
                      <td class="text-center">{{offer.availablePallets}}</td>
                      <td class="text-center"><p-button
                        icon="pi pi-eye"
                        class="custom-table-button"
                        pTooltip="{{'MarketplacePage.Spot.MarketPlaceTable.SeeAdOffer' | translate}}"
                        tooltipPosition="left"
                          (onClick)="navigateToDetail(offer.adsCode)"></p-button>
                      </td>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="18">{{'MarketplacePage.Spot.MarketPlaceTable.EmptyResultsText' | translate}}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>



              <p-dataView
                [value]="itemsFiltered"
                class="only-mobile mg-top"
                [paginator]="true"
                [rows]="10"
              >
                <ng-template let-offer pTemplate="listItem">
                  <div class="container-cards">
                    <app-product-card
                      class="w-full"
                      [offer]="offer"
                      (navigateTo)="navigateToDetail(offer.adsCode)"
                    />
                  </div>
                </ng-template>
              </p-dataView>

            </p-tabPanel>


            <p-tabPanel header="{{'ExternalMarketPlace.ImportRequestTabTitle' | translate}}">
              <div class="only-desktop">
                <div>
                  <form [formGroup]="importRequestForm" class="marketplace-filters-container">
                    <div class="p-fluid grid">
                      <div class="col-12 md:col-4 lg:col-2 pb-0 mb-0">
                        <span class="p-float-label">
                          <p-dropdown
                            [options]="originCountriesImportRequest"
                            formControlName="countryFromId"
                            optionLabel="name"
                            optionValue="id"
                            (onChange)="onChangeCountryFromImportRequest()"
                            (onClear)="clearSpotSearchParamsImportRequest()"
                            [filter]="true"
                            filterBy="name"
                            [showClear]="true"
                            placeholder="{{'MarketplacePage.Spot.ImportFromFieldPlaceholder' | translate}}"
                            class="p-inputtext-sm custom-dropdown bg-form">
                            <ng-template pTemplate="selectedItem">
                              <div class="flex align-items-center gap-2" *ngIf="selectedImportRequestCountryFrom">
                                <img [flag]="selectedImportRequestCountryFrom.code" style="width: 18px" alt="flag"/>
                                <div>{{ selectedImportRequestCountryFrom | countryDescription }}</div>
                              </div>
                            </ng-template>
                            <ng-template let-country pTemplate="item">
                              <div class="flex align-items-center gap-2">
                                <img [flag]="country" style="width: 18px" alt="flag"/>
                                <div>{{ country | countryDescription }}</div>
                              </div>
                            </ng-template>
                          </p-dropdown>
                          <label class="export-from-label">{{'MarketplacePage.Spot.ImportFromFieldLabel' | translate}}</label>
                        </span>
                      </div>
                      <div class="col-12 md:col-4 lg:col-6 pb-0 mb-0">
                        <span class="p-input-icon-left">
                          <i class="custom-input-icon pi pi-search"></i>
                          <input type="text" pInputText (input)="filterGlobalImportRequestEvent($event)"
                            placeholder="{{'MarketplacePage.Spot.SearchProducts' | translate}}"
                            class="custom-input w-full" />
                        </span>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div class="only-mobile pd-lat">
                <div>
                  <form [formGroup]="filterImportRequestForm" class="marketplace-filters-container">
                    <div class="p-fluid grid">
                      <div class="col-12 md:col-4 lg:col-6 pb-0 mb-0">
                        <span class="p-input-icon-left">
                          <i class="custom-input-icon pi pi-search"></i>
                          <input type="text" pInputText formControlName="filterMobile"
                            placeholder="{{'MarketplacePage.Spot.SearchProducts' | translate}}"
                            class="custom-input w-full" />
                        </span>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div class="only-desktop mg-top w-full">
                <p-table #dt2
                [value]="importRequests"
                dataKey="adsCode"
                [paginator]="true"
                [rows]="10"
                [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[10, 25, 50]"
                [loading]="loading"
                [globalFilterFields]="['variety.species.name', 'variety.name', 'speciesSize']"
                responsiveLayout="stack"
                [breakpoint]="'600px'"
                class="custom-table">

                <ng-template pTemplate="header">
                  <tr>
                    <th class="text-center">
                      <div class="flex align-items-center justify-content-center">
                        {{'MarketplacePage.WishList.WishListTable.CountryHeader' | translate}}
                      </div>
                    </th>
                    <th class="text-center">
                      <div class="flex align-items-center justify-content-center">
                        {{'MarketplacePage.WishList.WishListTable.SpecieHeader' | translate}}
                        <p-columnFilter field="specieName" matchMode="in" display="menu"
                        [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                        <ng-template pTemplate="header">
                          <div class="px-3 pt-3 pb-0">
                            <span class="font-bold">{{'MarketplacePage.Spot.MarketPlaceTable.SelectSpecieText' |
                              translate}}</span>
                          </div>
                        </ng-template>
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <p-multiSelect
                            [options]="speciesImporterFilter"
                            [ngModel]="value"
                            placeholder="{{'MarketplacePage.Spot.MarketPlaceTable.SelectText' | translate}}"
                            (onChange)="filter($event.value)"
                            optionValue="value"
                            optionLabel="label"/>
                        </ng-template>
                      </p-columnFilter>
                      </div>
                    </th>
                    <th class="text-center">
                      <div class="flex align-items-center justify-content-center">
                        {{'MarketplacePage.WishList.WishListTable.VarietyHeader' | translate}}
                        <p-columnFilter field="variety.name" matchMode="in" display="menu"
                        [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                        <ng-template pTemplate="header">
                          <div class="px-3 pt-3 pb-0">
                            <span class="font-bold">{{'MarketplacePage.Spot.MarketPlaceTable.SelectVarietyText' |
                              translate}}</span>
                          </div>
                        </ng-template>
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <p-multiSelect
                            [options]="varietiesImporterFilter"
                            [ngModel]="value"
                            placeholder="{{'MarketplacePage.Spot.MarketPlaceTable.SelectText' | translate}}"
                            (onChange)="filter($event.value)"
                            optionValue="value"
                            optionLabel="label"/>
                        </ng-template>
                      </p-columnFilter>
                        <p-sortIcon field="variety.name"></p-sortIcon>
                      </div>
                    </th>
                    <th class="text-center">
                      <div class="flex align-items-center justify-content-center">
                        {{'MarketplacePage.WishList.WishListTable.SpeciesSizeHeader' | translate}}
                        <p-columnFilter type="text" field="speciesSize" display="menu"
                        [showAddButton]="false" [showMatchModes]="false" [showOperator]="false"
                        [matchMode]="'contains'"></p-columnFilter>
                      <p-sortIcon field="speciesSize"></p-sortIcon>
                      </div>
                    </th>
                    <th class="text-center">
                      <div class="flex justify-content-center align-items-center">
                        {{'MarketplacePage.WishList.WishListTable.WeekRangeHeader' | translate}}
                      </div>
                    </th>
                    <th class="text-center">
                      <div class="flex align-items-center justify-content-center">
                        {{'MarketplacePage.WishList.WishListTable.TotalPalletsHeader' | translate}}
                      </div>
                    </th>
                    <th class="text-center">
                      <div class="flex align-items-center justify-content-center">
                        {{'MarketplacePage.WishList.WishListTable.TotalContainerHeader' | translate}}
                      </div>
                    </th>
                    <th class="text-center">
                      <div class="flex align-items-center justify-content-center">
                        {{'MarketplacePage.WishList.WishListTable.PricePerCase' | translate}}
                        <p-sortIcon field="pricePerCase"></p-sortIcon>
                      </div>
                    </th>
                    <th class="text-center" colspan="2">
                      <div class="flex align-items-center justify-content-center">
                        {{'MarketplacePage.Spot.MarketPlaceTable.SeeAdOffer' | translate}}
                      </div>
                    </th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-request>

                  <tr [pSelectableRow]="request">
                    <!--
                    -->
                    <td class="text-center">
                      <img [flag]="request.country" class="row-img" alt=""/>
                    </td>
                    <td class="text-center">
                      <img [src]="request.variety.urlIcon | speciesImageUrl" class="row-img" style="padding: 2px; border-radius: 7px;" alt=""/>
                    </td>
                    <td class="text-center">{{request.variety.name}}</td>
                    <td class="text-center">{{request.speciesSize}}</td>
                    <td class="text-center">
                      <div class="flex justify-content-center align-items-center flex-column">
                        <span>
                          {{ request.fromWeek }} ({{request.fromYearWeek }}) -
                          {{request.toWeek}} ({{request.toYearWeek }})
                        </span>
                        <span class="week-style">
                          {{getTotalWeeksImportRequest(request)}}
                          {{'MarketplacePage.WishList.WishListTable.WeekLabel' | translate }}
                        </span>
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="flex justify-content-center align-items-center flex-column">
                        {{getTotalPalletsImportRequest(request)}}
                      </div>
                    </td>
                    <td class="text-center">
                      <div class="flex justify-content-center align-items-center flex-column">
                        {{getTotalContainersImportRequest(request)}}
                      </div>
                    </td>
                    <td class="text-center"> {{request.pricePerCase | currency: 'USD':'US$'}}{{request.typeSale}}</td>
                    <td class="text-center">
                      <p-button icon="pi pi-eye"
                        pTooltip="{{'MarketplacePage.Spot.MarketPlaceTable.SeeAdOffer' | translate}}"
                        tooltipPosition="left"
                        (onClick)="navigateToImportRequestDetail(request.adsCode)"
                        class="custom-table-button">
                      </p-button>
                    </td>
                  </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="18">{{'MarketplacePage.Spot.MarketPlaceTable.EmptyResultsText' | translate}}</td>
                  </tr>
                </ng-template>
                </p-table>
              </div>

              <p-dataView
              [value]="importRequests"
              class="only-mobile mg-top"
              [paginator]="true"
              [rows]="10"
            >
              <ng-template let-importRequest pTemplate="listItem">
                <div class="container-cards">
                  <app-product-card
                    class="w-full"
                    [offer]="importRequest"
                    [pricePerCase]="importRequest.pricePerCase"
                    (navigateTo)="navigateToDetailImport(importRequest.adsCode)"
                  />
                </div>
              </ng-template>
            </p-dataView>
            </p-tabPanel>
          </p-tabView>
        </div>
      </div>
    </app-content-body>
  </app-user-dashboard>

<app-footer-home></app-footer-home>

